class Post {
  constructor(title = '', content = '', tags = [], publishedDate = new Date(), isPublished = false) {
    this.title = title;
    this.content = content;
    this.tags = tags;
    this.publishedDate = publishedDate;
    this.isPublished = isPublished;
  }
}

export default Post;
